import {Policy} from '../../types-repository';
import {globMatch, grantedPatterns, grantsValue} from '../../services/policy-access';

export const MOUNT_ACTION = 'contentplatform:repository:Mutation/MountEditingWorkspace';
export const POOL_RESOURCE = 'contentplatform:pool:input.pool/';

/**
 * The `pool` to send when mounting a workspace of `workspacePool` on a host of `hostPool`, or null when the
 * caller's policies allow no such mount.
 *
 * Two checks decide a mount, and the value must pass both:
 * - the authorizer: some allow statement's `input.pool` pattern matches the value, and no deny statement's does;
 * - the mount Lambda: the value, as a pattern, matches the volume's pool and the host's pool.
 * Candidates, most specific first: the workspace's own pool (when the host has the same pool), then each pattern a
 * policy grants (an admin's `*` covers another pool's host; an operator's names only its own pool).
 */
export function mountPool(policies: Policy[] | null | undefined, workspacePool: string | null | undefined,
                          hostPool: string | null | undefined): string | null {
  if (!workspacePool || !hostPool) {
    return null;
  }
  const grant = grantedPatterns(policies, MOUNT_ACTION, POOL_RESOURCE);
  const candidates = workspacePool === hostPool ? [workspacePool, ...grant.allow] : grant.allow;
  return candidates.find(value =>
    grantsValue(grant, value) && globMatch(value, workspacePool) && globMatch(value, hostPool)) ?? null;
}
